// @flow

import type {Hero, Weapon} from '../data/heroes';

export type Calculation = {
  name: string,
  formula: ?string,
  value: number
};

export type HeroCalculation = {
  hero: Hero,
  atkCalculation: Array<Calculation>,
  atkTotal: number
};


function calculate(heroes: Array<Hero>): Array<HeroCalculation> {
  return heroes.map((hero: Hero) => {
    const atkCalculation = [];
    const basic = hero.atk;
    atkCalculation.push({
      name: 'Basic Attack',
      formula: null,
      value: basic,
    });
    if (hero.criticalHitChance !== 0.0) {
      atkCalculation.push({
        name: 'Critical Attack',
        formula: `${hero.atk} * ${Math.round(hero.criticalHitChance * 100)}%`,
        value: Math.round(hero.criticalHitChance * hero.atk),
      });
    }
    for (const giver of heroes) {
      for (const skill of giver.skills) {
        const eligible = (
            skill.target === 'SELF' &&
            giver.name === hero.name
          ) ||
          hero.element === skill.target ||
          (
            skill.target === 'RANGED' &&
            hero.weapons.some(
              (weapon: Weapon) => {
                return [
                  'Bow',
                  'Staff',
                  'Rifle',
                  'Basket',
                ].includes(weapon);
              })
          ) || (
            skill.target === 'MELEE' &&
            hero.weapons.some(
              (weapon: Weapon) => {
                return [
                  'OneHandedSword',
                  'TwoHandedSword',
                  'Claw',
                  'Gauntlet'].includes(weapon);
              })
          ) ||
          skill.target === 'PARTY';
        if (eligible && skill.attribute === 'ATK') {
          atkCalculation.push({
              name: `Buff from ${giver.name}`,
              formula: `${hero.atk} * ${Math.round(skill.value * 100)}%`,
              value: Math.round(skill.value * hero.atk),
            },
          );
        }
      }
    }
    const atkTotal = atkCalculation.map((cal: Calculation) => cal.value)
      .reduce((a: number, b: number) => a + b, 0);

    return {
      hero,
      atkCalculation,
      atkTotal,
    };
  });
}


export default {calculate};
